const childrenLoaded = require('@alexspirgel/children-loaded');
const $ = jQuery;

class ComponentPopover extends HTMLDivElement {

	constructor() {
		super();
	}

	async connectedCallback() {
		await childrenLoaded(this);
		this.initialize();
	}

	initialize() {

		if (this.initialized) {
			return;
		}

		this.initializePopover();

		this.initialized = true;

	}

	closeOnEcape(e) {
		if (e.key === 'Escape') {
			console.log($('.ui-dialog.component-popover .ui-dialog-content').dialog("instance").close());
		}
	}

  initializePopover() {
    $(window).on('dialogopen', (e) => {
      $('html').addClass('has-dialog');
      $('body').addClass('has-dialog');
	  e.target.parentElement.querySelector('.ui-dialog-titlebar-close').focus();
	  window.addEventListener('keydown', this.closeOnEcape, true);
    });
    $(window).on('dialog:afterclose', (e) => {
      $('html').removeClass('has-dialog');
      $('body').removeClass('has-dialog');
	  this.focus();
	  window.removeEventListener('keydown', this.closeOnEcape, true);
    });
	}

}

customElements.define('component-popover', ComponentPopover, {extends: 'div'});